import { render, staticRenderFns } from "./pbTemlpate.vue?vue&type=template&id=e47de438&scoped=true&"
import script from "./pbTemlpate.vue?vue&type=script&lang=js&"
export * from "./pbTemlpate.vue?vue&type=script&lang=js&"
import style0 from "./pbTemlpate.vue?vue&type=style&index=0&id=e47de438&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e47de438",
  null
  
)

export default component.exports